import React, {
  useEffect,
  useState,
  useMemo,
  forwardRef,
  useCallback,
  useRef,
} from "react";
import {
  isEmpty,
  map,
  includes,
  compact,
  noop,
  forEach,
  isString,
  split,
  find,
  isNil,
} from "lodash";
import { Form, Button } from "antd";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import {
  FieldTypes,
  parseSelectOptions,
  generateFormFields,
} from "utils/formUtils";
import message from "components/CustomMessage";
import GenericMappingForm from "../GenericMappingForm";
import { SNYK_CATEGORY } from "../new/util";
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
/***
 * To Do : data caching on edit pending
 */
const initialFormValues = {
  product: undefined,
  subProduct: undefined,
  environment: undefined,
  configType: 'projects',
  snykProjectList: [{ target: undefined }],
};
const DELIMITER = ";";
const REFERENCE_DELIMITER = "|";

const SnykMappingFormNew = forwardRef(
  ({ disableProjectFields = false, ...props }, ref) => {
    const featureFlags = useFeatureFlag();
    const [collectionList, setCollectionList] = useState(() => {
      if (props.record && (!isNil(props.record.project_type) || props.record.project_type === 'collections')) {
        const { projectId, projectName } = props.record;
        const projectIdArray = projectId.split(',');
        const projectNameArray = projectName.split(',');
        return projectIdArray.map((id, index) => ({id, name: projectNameArray[index]}))
      }
      return [];
    });
    const [initialValues] = useState(() => {
      if (props.record) {
        return [];
      }
      return [
        {
          ...initialFormValues,
          product: props.defaultProduct,
          subProduct: props.defaultSubProduct,
          subProductId: props.defaultSubProductId,
          environment: props.defaultEnvironment,
        },
      ];
    });
    const referenceOptions = useRef([]);
    const [targetProjectList, setTargetProjectList] = useState(() => {
      // if (props.record) {
      // const { orgId , projectId, targetId } = props.record;
      // const projectIdArray = projectId.split(',');
      // const targetIdArray = targetId.split(',')
      // const projects = map(projectIdArray, (projectWithReference, i) => {
      //   // geting first index of ';'
      //   const index = projectWithReference.indexOf(DELIMITER);
      //   const projectIndex = projectWithReference.indexOf(REFERENCE_DELIMITER)
      //   if(index !== -1 && projectIndex === -1){
      //     const target = projectWithReference.substring(0, index);
      //     const references = projectWithReference.substring(index + 1, projectWithReference.length);
      //     return { target, references: split(references.replace(/;/g, ','), ',') , targetId: targetIdArray[i]};
      //   } else if(index !== -1 && projectIndex !== -1){
      //     const target = projectWithReference.substring(0, index);
      //     const references = projectWithReference.substring(index + 1, projectIndex);
      //     const projects = projectWithReference.substring(projectIndex + 1, projectWithReference.length)
      //     return { target, references: split(references.replace(/;/g, ','), ',') , project: split(projects.replace(/\|/g, ','), ',')  ,targetId: targetIdArray[i]};
      //   } else if(index === -1 && projectIndex !== -1){
      //     const target = projectWithReference.substring(0, projectIndex);
      //     const projects = projectWithReference.substring(projectIndex + 1, projectWithReference.length)
      //     return { target, project: split(projects.replace(/\|/g, ','), ','), targetId: targetIdArray[i]};
      //   }
      //   return { target: projectWithReference, targetId: targetIdArray[i] }
      // });

      // return {
      //   [orgId]: projects.map(({ target, references, targetId }) => ({id: target, name: target , otherProperties: { references, targetId} }))
      // }
      // }
      return {};
    });
    const [projectList, setProjectsList] = useState(() => {
      // if (props.record) {
      //   const { projectId,projectName, targetId } = props.record;
      //   console.log(props.record, 'otherProperties')
      //   const projectNameArray = projectName.split(',');
      //   const projectIdArray = projectId.split(',');
      //   const targetIdArray = targetId.split(',')
      //   const projects = map(projectIdArray, (projectWithReference, i) => {
      //     // geting first index of ';'
      //     const projectNameWithReference = projectNameArray[i];
      //     const _projectIndex = projectNameWithReference.indexOf(REFERENCE_DELIMITER)
      //     const projectIndex = projectWithReference.indexOf(REFERENCE_DELIMITER)
      //     if(projectIndex !== -1){
      //       const projects = projectWithReference.substring(projectIndex + 1, projectWithReference.length);
      //       const projectNames = projectNameWithReference.substring(_projectIndex + 1, projectNameWithReference.length);
      //       return  { project: split(projects.replace(/\|/g, ','), ',') , projectName: split(projectNames.replace(/\|/g, ','), ',') ,targetId: targetIdArray[i]}
      //     }
          
      //     return { targetId: targetIdArray[i] }
      //   });
      //   const transformedData = {};

      //   projects.forEach(item => {
      //     const transformedProjects = (item.project && item.projectName) ? 
      //       item.project.map((project, index) => {
      //         return {
      //           id: project,
      //           name: item.projectName[index]
      //         };
      //       }) : [];
      //     transformedData[item.targetId] = transformedProjects;
      //   });
      //   return transformedData;
      // }
      return {};
    });
    const [organisationList, setOrganisationList] = useState(() => {
      if (props.record) {
        const { orgId, orgName } = props.record;
        return [{ id: orgId, name: orgName }];
      }
      return [];
    });
    const [organisation, setOrganisation] = useState(() => {
      if (props.record) {
        const { orgId } = props.record;
        return orgId;
      }
      return "";
    });
    const [exploitOptions, setExploitOptions] = useState(() => {
      if (props.record) {
        const { exploitMaturity } = props.record;
        return exploitMaturity?.split(",");
      }
      return [];
    });
    const [target, setTarget] = useState();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const { promise, cancel } =
        ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
          login_id: props.loginConfigId,
        });
      promise
        .then((response) => {
          const { projects } = response;
          setOrganisationList(projects);
        })
        .catch(() => {
          message.error("Problem fetching projects");
        });

      return cancel;
    }, [props.loginConfigId, props.toolName]);

    const fetchProjects = useCallback(
      (organisation) => {
        if (organisation) {
          const { promise, cancel } =
            ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
              login_id: props.loginConfigId,
              organisation,
            });

          promise
            .then((response) => {
              const { projects } = response;
              setTargetProjectList((targetProjectList) => ({
                ...targetProjectList,
                [organisation]: projects,
              }));
            })
            .catch(() => {
              message.error("Problem fetching targets");
            });

          return cancel;
        }
      },
      [props.loginConfigId, props.toolName]
    );

  
    const fetchProjectsList = useCallback(
      (target) => {
        if (target) {
          const { promise, cancel } =
            ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, {
              login_id: props.loginConfigId,
              organisation,
              project: target,
            });

          promise
            .then((response) => {
              const { projects } = response;
              setProjectsList((projectList) => ({
                ...projectList,
                [target]: projects,
              }));
            })
            .catch(() => {
              message.error("Problem fetching projects");
            });

          return cancel;
        }
      },
      [organisation, props.loginConfigId, props.toolName]
    );

    useEffect(() => {
      fetchProjects(organisation);
    }, [organisation, fetchProjects]);

    useEffect(() => {
      if (organisation) {
        const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(
          props.toolName, 
          { login_id: props.loginConfigId, organisation, type: 'collections' }
        );

        promise.then(response => {
          const { projects } = response;
          setCollectionList(projects);
        }).catch(() => {
          message.error('Problem fetching collections');
        });

        return cancel;
      }
    }, [organisation, props.loginConfigId, props.toolName]);

    useEffect(() => {
      fetchProjectsList(target);
    }, [target, fetchProjectsList]);

    useEffect(() => {
      setLoading(true);
      const { promise, cancel } = ToolsIntegrationsAPI.getSnykExploitOptions();
      promise
        .then((res) => setExploitOptions(res))
        .catch((err) => console.log(err))
        .finally(() => setLoading(false));
      return cancel;
    }, []);

    const parseExtraFieldsDataFromResponse = useCallback((config) => {
      const { projectId, exploitMaturity, scanType, targetId, project_type } = config;
      
      if (!isEmpty(project_type) && project_type === 'collections') {
        return {
          collection: projectId.split(','),
          exploitMaturity: isEmpty(exploitMaturity) ? undefined : exploitMaturity.split(','),
          scanType: isEmpty(scanType) ? undefined : scanType.split(','),
          configType: 'collections'
        };
      }
      
      const targetIdArray = split(targetId, ',');
      const snykProjectList = map(split(projectId, ","), (targetProject, i) => {
        const index = targetProject.indexOf(DELIMITER);
        const projectIndex = targetProject.indexOf(REFERENCE_DELIMITER);
        let target;
        let references;
        let project;

        if (featureFlags.SNYK_TARGET_ORIGIN) {
          target = targetIdArray[i];
        } else {
          const endIndex = index !== -1 ? index : (projectIndex !== -1 ? projectIndex : targetProject.length);
          target = targetProject.substring(0, endIndex);
        }

        if (index !== -1) {
          references = targetProject.substring(
            index + 1,
            targetProject.substring(
              0,
              projectIndex !== -1 ? projectIndex : targetProject.length
            ).length
          );
        }
        if (projectIndex !== -1) {
          project = targetProject.substring(
            projectIndex + 1,
            targetProject.length
          );
        }
        setTarget(targetIdArray[i]);
        return {
          project: compact(split(project, "|")),
          target,
          references: !isEmpty(references)
            ? split(references.replace(/;/g, ","), ",")
            : [],
        };
      });
    
      return {
        snykProjectList,
        exploitMaturity: isEmpty(exploitMaturity)
          ? undefined
          : exploitMaturity?.split(","),
        scanType: isEmpty(scanType) ? undefined : scanType.split(","),
        configType: 'projects'
      };
    }, [featureFlags.SNYK_TARGET_ORIGIN]);

    const onOrganisationChange = useCallback(
      (value, field) => {
        setOrganisation(value);
        const { name } = field;
        const configurations = form.getFieldValue("configurations");
        const updatedConfiguration = [...configurations];
        updatedConfiguration[name] = {
          ...updatedConfiguration[name],
          snykProjectList: [{ target: undefined, project: undefined }],
        };
        form.setFieldsValue({ configurations: updatedConfiguration });
      },
      [form]
    );

    const getExtraFieldsData = useCallback(
      (config) => {
        const { snykProjectList, orgId, exploitMaturity, scanType, collection, configType } = config;
        
        if (configType === 'collections') {
          const collectionData = collectionList.reduce((acc, cv) => {
            const { id, name } = cv;
            if (collection.includes(id)) {
              acc.id.push(id);
              acc.name.push(name);
            }
            return acc;
          }, { id: [], name: [] });
          
          return {
            projectId: collectionData.id.join(),
            projectName: collectionData.name.join(),
            orgId,
            orgName: organisationList.find((org) => org.id === orgId)?.name,
            exploitMaturity: isEmpty(exploitMaturity) ? [] : exploitMaturity.join(),
            scanType: isEmpty(scanType) ? [] : scanType.join(),
            project_type: 'collections',
            ...(config.discovery_config_id && {
              discovery_config_id: config.discovery_config_id,
            }),
          };
        }
        
        const targetId = [];
        const origins =[]
        const isEmptyList = [];
        const projectId = map(
          snykProjectList,
          ({ target, project, references }) => {
            if(featureFlags.SNYK_TARGET_ORIGIN){
              const _targetId = target;
              const targetProject = targetProjectList[orgId].filter(p=>p?.otherProperties?.targetId===target)[0]
              targetId.push(_targetId);
              const isEmptyProperty = targetProject?.otherProperties.isEmpty ?? null;
              isEmptyList.push(isEmptyProperty === null ? 'null' : isEmptyProperty);
              const origin = targetProject?.otherProperties.origin;
              origins.push(origin);

              return (
                targetProject?.name +
                (!isEmpty(references)
                  ? DELIMITER + references.join(DELIMITER)
                  : "") +
                (!isEmpty(project)
                  ? REFERENCE_DELIMITER + project.join(REFERENCE_DELIMITER)
                  : "")
              );
            } else {
              const targetProject = find(targetProjectList[orgId], ['id', target]);
              const _targetId = targetProject.otherProperties.targetId;
              targetId.push(_targetId);
              const isEmptyProperty = targetProject.otherProperties.isEmpty ?? null;
              isEmptyList.push(isEmptyProperty === null ? 'null' : isEmptyProperty);
              const origin = targetProject.otherProperties.origin;
              origins.push(origin);

              return (
                target +
                (!isEmpty(references)
                  ? DELIMITER + references.join(DELIMITER)
                  : "") +
                (!isEmpty(project)
                  ? REFERENCE_DELIMITER + project.join(REFERENCE_DELIMITER)
                  : "")
              );
            }
          }
        );
        const projectName = map(
          snykProjectList,
          ({ target, project, references }) => {
            const _targetId = featureFlags.SNYK_TARGET_ORIGIN ? target : find(targetProjectList[orgId], ['id', target]).otherProperties.targetId;
            const targetProject = targetProjectList[orgId].filter(p=>p?.otherProperties?.targetId===target)[0]
            const names = map(
              project,
              (pId) =>
                find(projectList[_targetId], (proj) => proj.id === pId)?.name
            );

            const targetName = featureFlags.SNYK_TARGET_ORIGIN ? targetProject?.name : find(targetProjectList[orgId], ['id', target])?.name;
            return (
              targetName +
              (!isEmpty(references)
                ? DELIMITER + references.join(DELIMITER)
                : "") +
              (!isEmpty(compact(names))
                ? REFERENCE_DELIMITER + names.join(REFERENCE_DELIMITER)
                : "")
            );
          }
        );
        return {
          projectId: projectId.join(),
          projectName: projectName.join(),
          orgId,
          isEmptyList: isEmptyList.join(),
          origin:origins.join(),
          orgName: organisationList.find((org) => org.id === orgId)?.name,
          exploitMaturity: isEmpty(exploitMaturity)
            ? []
            : exploitMaturity.join(),
          scanType: isEmpty(scanType) ? [] : scanType.join(),
          project_type: 'project',
          ...(!isEmpty(compact(targetId)) && { targetId: targetId.join() }),
          //send the property received in config
          ...(config.discovery_config_id && {
            discovery_config_id: config.discovery_config_id,
          }),
        };
      },
      [organisationList, projectList, targetProjectList, collectionList, featureFlags.SNYK_TARGET_ORIGIN]
    );

    const snykProjectOptions = useCallback(
      (projects, listField) => {
        const selected = compact(
          map(
            form.getFieldsValue().configurations?.[listField.name]
              ?.snykProjectList,
            (p) => p?.target
          )
        );
        return map(projects, (p) => ({
          ...p , ...((featureFlags.SNYK_TARGET_ORIGIN && p.otherProperties?.origin)?{label:`[${p.otherProperties?.origin}] `+p?.label, value:p.otherProperties?.targetId}:{}) ,
          disabled: includes(selected, featureFlags.SNYK_TARGET_ORIGIN ? p?.otherProperties?.targetId : p?.id),
        }));
      },
      [form,featureFlags.SNYK_TARGET_ORIGIN]
    );

    const findProjectByName = useCallback((project, name) => {
      for (const key in project) {
        if (( featureFlags.SNYK_TARGET_ORIGIN && project[key]?.otherProperties?.targetId === name) || project[key]?.id === name) {
          return project[key];
        }
      }
      return null;
    },[featureFlags.SNYK_TARGET_ORIGIN]);

    const onValuesChange = useCallback(
      (values, ...args) => {
        if (values.configurations) {
          let isProjectChanged = false;
          const formValues = form.getFieldsValue();
          forEach(values.configurations, (configs, index) => {
            // since this is a list field, onchange will trigger only for the changed row.
            // if change is done at 2nd row, data received in this callback will only contain 2nd row data
            // configs.snykProjectList is given as string when we search in the field
            if (
              !configs ||
              !configs.snykProjectList ||
              isString(configs.snykProjectList)
            ) {
              return;
            }
            forEach(configs.snykProjectList, (object, i) => {
              // since this is a list field, onchange will trigger only for the changed row.
              // if change is done at 2nd row, data received in this callback will only contain 2nd row data
              // Also checking if the object contains `project` and nothing else
              // because we need to reset the references field only if the project is changed
              // and this change is also triggered when rows are added or deleted, so we need to ignore it
              if (object && object.target && Object.keys(object).length === 1) {
                isProjectChanged = true;
                formValues.configurations[index].snykProjectList[i].references =
                  undefined;
                formValues.configurations[index].snykProjectList[i].project =
                  undefined;
              }
            });
          });
          if (isProjectChanged) {
            form.setFieldsValue(formValues);
          }
        }
      },
      [form]
    );

    const projectListRender = useCallback(
      (listField) => {
        const selectedType = form.getFieldsValue().configurations[listField.name]?.configType;
        
        const collectionFields = [
          {
            name: [listField.name, "collection"],
            type: FieldTypes.MULTI_SELECT,
            label: 'Collection',
            disabled: isEmpty(collectionList) || disableProjectFields,
            loading: organisation && isEmpty(collectionList),
            colSpan: 10,
            options: collectionList,
            required: true,
          },
          {
            colSpan: 10,
            type: FieldTypes.LABEL
          }
        ];
        
        const targets = snykProjectOptions(parseSelectOptions(targetProjectList[organisation]), listField);
        let refOptionAPI = referenceOptions.current[listField.name];

        if (!refOptionAPI) {
          refOptionAPI = referenceOptions.current[listField.name] = ({
            listFieldName: nestedListFieldName,
            ...params
          }) => {
            const allConfigs = form.getFieldsValue().configurations;
            const target =
              allConfigs[listField.name]?.snykProjectList[nestedListFieldName]
                ?.target;
            if (!target) {
              return { promise: Promise.resolve([]), cancel: noop };
            }

            const refObj = findProjectByName(params, target);
            const refrenceArray =
              isEmpty(refObj) || isEmpty(refObj.otherProperties.references)
                ? []
                : refObj.otherProperties.references;
            return { promise: Promise.resolve(refrenceArray), cancel: noop };
          };
        }

        const onTargetChange = (value, field) => {
          if(featureFlags.SNYK_TARGET_ORIGIN) {
            setTarget(value);
          } else{
            const _tragetId = find(targetProjectList[organisation], ['name', value]).otherProperties.targetId;
            setTarget(_tragetId);
          }
        }

        const __fields = [
          {
            name: "target",
            label: "Target",
            required: true,
            type: FieldTypes.SELECT,
            disabled: isEmpty(targets) || disableProjectFields,
            loading: organisation && isEmpty(targetProjectList),
            colSpan: 10,
            options: targets,
            props: {
              onChange: onTargetChange,
            },
          },
          {
            name: "references",
            label : "References",
            type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
            disabled: isEmpty(targets) || disableProjectFields,
            colSpan: 10,
            props: {
              mode: "multiple",
              api: refOptionAPI,
              apiParams: targets,
              setExtraProps: (field, nestedListField) => {
                const allConfigs = form.getFieldsValue().configurations;
                const project =
                  allConfigs[listField.name]?.snykProjectList[
                    nestedListField.name
                  ]?.target;
                return {
                  showValueOnload: false,
                  resetOptionsProp: project,
                };
              },
            },
          },
          {
            name: "project",
            label: "Project",
            type: FieldTypes.MULTI_SELECT,
            disabled: isEmpty(targets) || disableProjectFields,
            // loading: target && isEmpty(projectList),
            colSpan: 10,
            props: {
              getFormListOptions: (nestedListField) => {
                const configs = form.getFieldValue("configurations");
                const selectedTargetProject = configs[listField.name]?.snykProjectList[nestedListField]?.target;
                const organisationId = configs[listField.name]?.orgId;
                const _nestedTeargetId = find(targetProjectList[organisationId], ['name', selectedTargetProject])?.otherProperties.targetId;
                const nestedTeargetId = featureFlags.SNYK_TARGET_ORIGIN ? selectedTargetProject : _nestedTeargetId;
                const references = configs[listField.name]?.snykProjectList[nestedListField]?.references || [];
                const filteredProject = projectList[nestedTeargetId] ? references.length === 0 ? projectList[nestedTeargetId] : projectList[nestedTeargetId].filter(item => references.includes(item.otherProperties.reference)) : []
                return parseSelectOptions(filteredProject)
              },
            },
          },
          {
            name: "add",
            colSpan: 2,
            render: ({ remove, name, fields }) => {
              return (
                <Button
                style={{marginTop: 24}}
                  disabled={fields.length === 1}
                  type="dashed"
                  onClick={() => {
                    remove(name);
                  }}
                >
                  -
                </Button>
              );
            },
          },
        ];

        return (
          <div className="m-b-sm">
            {selectedType === 'projects' ? (
              <Form.List name={[listField.name, "snykProjectList"]}>
                {(fields, { add, remove }) => {
                  return (
                    <div>
                      {map(fields, (field) => {
                        return generateFormFields(
                          __fields,
                          10,
                          { ...field, add, remove, fields },
                          field.name
                        );
                      })}
                      <Button
                        size="small"
                        type="dashed"
                        onClick={() => add({ target: undefined })}
                        disabled={disableProjectFields}
                      >
                        + Add Target
                      </Button>
                    </div>
                  );
                }}
              </Form.List>
            ) : (
              generateFormFields(collectionFields)
            )}
          </div>
        );
      },
      [
        disableProjectFields,
        form,
        targetProjectList,
        projectList,
        organisation,
        collectionList,
        snykProjectOptions,
        featureFlags.SNYK_TARGET_ORIGIN,
        findProjectByName
      ]
    );

    const extraFields = useMemo(
      () => [
        {
          name: 'configType',
          type: FieldTypes.RADIO,
          options: [{label: "Projects", value: "projects" }, {label: "Collection", value: "collections" }],
          disabled: disableProjectFields,
        },
        {
          name: "orgId",
          colSpan: "10",
          type: FieldTypes.SELECT,
          label: "Organization",
          options: parseSelectOptions(organisationList),
          required: true,
          disabled: disableProjectFields,
          props: {
            onChange: onOrganisationChange,
            autoFocus: !disableProjectFields,
          },
        },
        {
          name: (listField) => [listField.name, "snykProjectList"],
          render: projectListRender
        },
        {
          label: "Scan Type",
          name: "scanType",
          colSpan: 10,
          type: FieldTypes.MULTI_SELECT,
          options: SNYK_CATEGORY,
        },
        {
          name: "exploitMaturity",
          colSpan: 13,
          type: FieldTypes.MULTI_SELECT,
          label: "Exploit Maturity",
          loading: loading,
          options: exploitOptions,
        },
      ],
      [disableProjectFields, organisationList, onOrganisationChange, projectListRender, loading, exploitOptions]
    );

    return (
      <GenericMappingForm
        form={form}
        ref={ref}
        getExtraFieldsData={getExtraFieldsData}
        extraFields={extraFields}
        parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
        formDefaultValues={initialValues}
        newRowDefaultValue={initialValues[0]}
        onValuesChange={onValuesChange}
        {...props}
      />
    );
  }
);

export default SnykMappingFormNew;